import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MediaChange, MediaObserver} from '@angular/flex-layout';
import {CoolService} from './cool.service';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  mainNavigationOpened = new BehaviorSubject<boolean>(false);
  mainNavigationMode = new BehaviorSubject<string>('side');

  constructor(private coolService: CoolService,
              private mediaObserver: MediaObserver) {
    /*
    this.media.media$.subscribe((change: MediaChange) => {
      if (change.mqAlias === 'xs' || change.mqAlias === 'sm') {
        this.setMainNavigationMode('over');
        this.setMainNavigationOpened(false);
      } else {
        this.setMainNavigationMode('side');
        this.setMainNavigationOpened(true);
      }
    });
    */
    this.mediaObserver.asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      ).subscribe((change: MediaChange) => {
        if (change.mqAlias === 'xs' || change.mqAlias === 'sm') {
          this.setMainNavigationMode('over');
          this.setMainNavigationOpened(false);
        } else {
          this.setMainNavigationMode('side');
          this.setMainNavigationOpened(true);
        }
      });
  }

  setMainNavigationMode(mode: string): void {
    this.mainNavigationMode.next(mode);
  }

  setMainNavigationOpened(opened: boolean): void {
    this.mainNavigationOpened.next(opened);
  }

  toggleMainNavigationOpened(): void {
    this.setMainNavigationOpened(!this.mainNavigationOpened.getValue());
  }

}
